/* @flow */
import React from 'react';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import cx from 'classnames';
import './styles/FormSingle.scss';

class FormSingle extends React.Component {
  static propTypes = {
    children(props, propName) {
      if (React.Children.count(props[propName]) !== 2) {
        return new Error('FormSingle expects two child elements');
      }
    },
    reset: React.PropTypes.oneOf(['mobile']),
  };

  static propClasses = {
    reset: {
      mobile: 'FormSingle--reset--mobile',
    },
  };

  render() {
    return (
      <div className={cx('FormSingle', getPropClassesFromInstance(this), this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}

export default FormSingle;



// WEBPACK FOOTER //
// ./src/components/FormSingle.jsx